module.exports = __webpack_public_path__ + "static/media/logo-twitter.27ff8f62.svg";